import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resetGenericError } from './../actions/FormationActions';

class ErrorModal extends Component {
    constructor(props) {
        super(props);
        this.state = { msg: null, icon: this.props.icon };
        this.timeout = null;
    }

    setCommonState(nextProps) {
        const ERROR = nextProps.error;
        this.setState({ msg: ERROR });
        if (ERROR) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                // this.props.resetGenericError();
            }, 300000);
        }
    }

    componentDidMount() {
        this.setCommonState(this.props);
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    componentWillReceiveProps(nextProps) {
        this.setCommonState(nextProps);
    }

    // render() {
    //     return this.state.msg ? <div className="si-modal-wrap">
    //         <div className="si-toast"><span>{this.state.msg}</span></div>
    //     </div> : null;
    // }

    render() {
        return this.state.msg ? <div id={ "modal" }>
            <div className="si-common-toast" onClick={ () => this.props.resetGenericError() }>
                <div className="si-common-popup si-warning-toast">
                    <div className="si-popup-body si-flexBox">
                        <div className="si-logo-wrap si-autofill-max">
                            {/* <div className="si-club-img">
                        <span>{ this.props.trans["short" + this.props.error.skill] }</span>
                    </div> */}
                            <div className="si-constraint-info">
                                <i className={ this.state.icon } />
                            </div>
                        </div>
                        <div className="si-details-wrap">
                            <div className="si-more-info">
                                { this.state.msg }

                            </div>
                        </div>
                        <i className="si-close icon-ucl-close" onClick={ () => this.props.resetGenericError() } />
                    </div>
                </div>
            </div>
        </div > : null;
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        resetGenericError: () => dispatch(resetGenericError()),
    };
};
export default connect(null, mapDispatchToProps)(ErrorModal);


// WEBPACK FOOTER //
// ./src/components/GenericMessage.js